<template>
  <section class="page-container">
    <!--工具条-->
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <!--
        <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"></el-input>
        </el-form-item>
        -->
        <el-form-item>
          <el-button type="primary" @click="list">刷新</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--列表-->
    <el-table
      ref="dataTable"
      v-loading="listLoading"
      :data="results"
      highlight-current-row
      stripe
      border
      :height="tableHeight"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="cover" label="封面图">
        <template slot-scope="scope">
          <img :src="scope.row.cover" style="max-width: 50px; max-height: 50px" />
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="优惠金额"></el-table-column>
      <el-table-column prop="description" label="优惠券描述"></el-table-column>
      <el-table-column prop="indateDays" label="有效期（天）"></el-table-column>
      <el-table-column prop="minPrice" label="最低使用价格"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">{{ scope.row.status | status }}</template>
      </el-table-column>
      <el-table-column prop="createUserId" label="创建人编号"></el-table-column>
      <el-table-column prop="createUserName" label="创建人名称"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="updateUserId" label="更新人编号"></el-table-column>
      <el-table-column prop="updateUserName" label="更新人名称"></el-table-column>
      <el-table-column prop="updateTime" label="修改时间"></el-table-column>
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="small" type="primary" @click="handleSend(scope.$index, scope.row)"
            >发放</el-button
          >
          <el-button size="small" type="danger" @click="handleSendAll(scope.$index, scope.row)"
            >全员发放</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="名称">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="封面图">
          <image-upload v-model="addForm.cover" />
        </el-form-item>
        <el-form-item label="优惠金额">
          <el-input v-model="addForm.amount"></el-input>
        </el-form-item>
        <el-form-item label="优惠券描述">
          <el-input v-model="addForm.description"></el-input>
        </el-form-item>
        <el-form-item label="有效期（天）">
          <el-input v-model="addForm.indateDays"></el-input>
        </el-form-item>
        <el-form-item label="最低使用价格">
          <el-input v-model="addForm.minPrice"></el-input>
        </el-form-item>
        <el-form-item label="可使用商品ID">
          <el-input
            v-model="addForm.productIds"
            placeholder="多个商品ID请使用【英文逗号】分割"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="id">
          <el-input v-model="editForm.id"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="封面图">
          <image-upload v-model="editForm.cover" />
        </el-form-item>
        <el-form-item label="优惠金额">
          <el-input v-model="editForm.amount"></el-input>
        </el-form-item>
        <el-form-item label="优惠券描述">
          <el-input v-model="editForm.description"></el-input>
        </el-form-item>
        <el-form-item label="有效期（天）">
          <el-input v-model="editForm.indateDays"></el-input>
        </el-form-item>
        <el-form-item label="最低使用价格">
          <el-input v-model="editForm.minPrice"></el-input>
        </el-form-item>
        <el-form-item label="可使用商品ID">
          <el-input
            v-model="editForm.productIds"
            placeholder="多个商品ID请使用【英文逗号】分割"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <status-select v-model="editForm.status" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--发放优惠券-->
    <el-dialog title="发放" :visible.sync="sendFormVisible" :close-on-click-modal="false">
      <el-form ref="sendForm" :model="sendForm" label-width="120px">
        <el-form-item label="名称">
          <el-input v-model="sendForm.couponId"></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="sendForm.userId"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="sendFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="sendLoading" @click.native="doSend">发放</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import ImageUpload from "@/components/ImageUpload";
import StatusSelect from "@/components/StatusSelect";
export default {
  name: "Coupon",
  components: { MyPagination, ImageUpload, StatusSelect },
  data() {
    return {
      tableHeight: 700,
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,

      sendForm: {
        couponId: 0,
        userIds: [],
      },
      sendFormVisible: false,
      sendLoading: false,
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/coupon/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      try {
        await this.axios.post("mall:/api/admin/coupon/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/coupon/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        await this.axios.post("mall:/api/admin/coupon/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    handleSend(index, row) {
      this.sendForm.couponId = row.id;
      this.sendForm.userIds = [];
      this.sendFormVisible = true;
    },
    async doSend() {
      this.sendLoading = true;
      try {
        if (this.sendForm.userId) {
          this.sendForm.userIds.push(this.sendForm.userId);
        }
        await this.axios.post("mall:/api/admin/user-coupon/create", this.sendForm);
        this.$notify.success("优惠券发放成功");
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.sendLoading = false;
        this.sendFormVisible = false;
        this.sendForm = {};
      }
    },

    handleSendAll(index, row) {
      const me = this;
      this.$confirm("请确认：是否全员赠送该优惠券！！！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          me.axios
            .post(`mall:/api/admin/user-coupon/giveAll?couponId=${row.id}`)
            .then(() => {
              this.$notify.success("任务提交成功，系统正在赠送优惠券中...");
            })
            .catch((e) => {
              me.$notify.error({ title: "错误", message: e.message || e });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped></style>
